module.exports = __webpack_public_path__ + "static/itsm_ad_1-9734df827a3f565cc5aa784b840a2878.png";